import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {TopNotificationsComponent} from './top-notifications.component';
import {NotificationModule} from '../../dumb/notification/notification.module';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [TopNotificationsComponent],
  imports: [CommonModule, MatIconModule, NotificationModule, RouterModule],
  exports: [TopNotificationsComponent],
})
export class TopNotificationsModule {}
